const main = {
  topbar: {
    home: '主页',
    setting: '设置',
    language: '简中',
    user: '用户',
    systemSetting: '系统设定',
    version: '版本'
  },
  menu: {
    homepage: '主页'
  },
  user: {
    user: '用户',
    loginTime: '登录时间',
    logout: '登出',
    profile: '个人信息'
  },
  forget: {
    back: '返回',
    next: '下一步',
    Account_Recovery: '帐号恢復',
    Recover_Account_Password: '恢復帐户密码'
  },
  signIn: '登录',
  account: '帐号',
  password: '密码',
  rememberMe: '记住我',
  forgetPassword: '忘记密码?',
  learnMore: '了解详情',
  contactTo: '请联系 ',
  error: 'Error',
  licenseVerificationFailed: '我们无法验证此服务的授权信息。',
  limitationVerificationFailed: 'SPEC 文件不合法。',
  returnToLogin: '返回登录'
};

const systemSetting = {
  uiTheme: '界面主题',
  timeZone: '时区',
  about: '关于',
  version: '版本',
  newPwdNotSame: '两次输入的新密码不一致',
  changePwdSuccess: '修改密码成功',
  changePwdFailed: '修改密码失败',
  oldPasswordError: '修改密码失败，旧密码错误',
  choseTheme: '选择主题',
  choseZone: '选择时区',
  passwordLengthErr: '密码不能为空，且长度必须在 8 至 20 字元',
  passwordError: '密码不正确',
  passwordPolicyErr: '新密码不符合规则 <br/>' + '密码原则：<br/>' +
  '8 至 20 个字符<br/>' +
  '至少1个数字<br/>' +
  '至少1个小写字母<br/>' +
  '至少1个大写字母<br/>' +
  '至少1个特殊字符<br/>' +
  '禁止空格（space）或定位（tab）字符',
  productInfo: {
    uploadConfig: '将zip档点击上传',
    uploadConfigSuccess: '上传成功',
    uploadConfigFailed: '上传失败',
    productConfig: '产品设定',
    productDetail: '产品信息',
    productName: '产品名称',
    productFavicon: 'favicon',
    pageTitle: '文件标籤名称',
    loginPage: '登入页',
    loginPageTitleUseText: '使用文字主标',
    loginPageTitle: '文字主标',
    loginPageSubtitle: '文字副标',
    loginPageTitleImage: '图片主标',
    loginPageTitleLogoImage: '图片 Logo',
    loginPageBackground: '背景',
    loginPageBackground_1280: '背景 (1280px)',
    loginPageBackground_1920: '背景 (1920px)',
    loginPageBackground_max: '背景 (max)',
    showForgetPwd: '显示\'忘记密码\'',
    showLoginType: '显示\'登入类型\'',
    mainPage: '主页',
    mainLogoImage: '横幅 Logo',
    mainLogoTitle: '横幅主标',
    mainHeaderBgcolor: '横幅背景色',
    enablePowerBy: '显示 \'Powered By\'',
    powerByLogo: '\'Powered By\' Logo 图片',
    enableWatermark: '显示水印',
    watermarkLogo: '水印 Logo 图',
    goToForum: '显示开启论坛',
    goToDocument: '显示开启文件'
  }
};

const versionHistory = {
  VersionHistory: '版本纪录',
  version: '版本',
  date: '日期',
  description: '描述',
  upgrade: '升级'
}

const userProfile = {
  username: '用户姓名',
  email: '用户 ID ',
  role: '角色',
  changePassword: '更改密码',
  oldPassword: '旧密码',
  newPassword: '新密码',
  confirmPassword: '确认密码',
  cancel: '取消',
  save: '保存'
};

const orgList = {
  name: '组织名字',
  id: '组织ID',
  sketchboard: '画图板',
  dataSource: '数据源',
  createdBy: '创建者',
  role: '角色',
  user: '用户',
  search: '搜索组织',
  enterOrgName: '请输入组织名字',
  add: '+ 添加组织',
  limit: '0 个组织可添加',
  limitMessage: '标准版最多可以包含{num}个组织。要无限组织（以及更多），请升级到专业版。',
  view: '查看',
  manage: '管理',
  delete: '删除',
  save: '保存',
  cancel: '取消',
  alarm: '确认删除？(请再次输入组织名称)',
  rename: '重新命名',
  remind: '提示',
  message: {
    emptyName: '组织名称不能为空',
    nameLengthLimit: '名称长度限制为 64 字元',
    deleteSuccess: '删除组织成功',
    deleteFailed: '删除组织失败',
    addSuccess: '增加组织成功',
    addFailed: '增加组织失败',
    addFailedRepeatName: '组织名称已被使用中，请输入新的名称',
    modifySuccess: '修改组织成功',
    modifyFailed: '修改组织失败',
    getDataError: '获取组织信息失败',
    policyErr: '组织名称格式不正确'
  }
};

const dataSource = {
  chose: '请选择',
  name: '数据源名字',
  type: '数据源类型',
  search: '搜索数据源',
  add: '+ 添加数据源',
  advanced: '高级',
  plugin: '插件',
  importDataSource: '导入数据源',
  manage: '管理',
  edit: '编辑',
  delete: '删除',
  save: '保存',
  confirm: '确认',
  cancel: '取消',
  alarm: '确认删除该数据源？',
  remind: '提示',
  nodeRed: 'Data-Director',
  importConfig: '导入配置',
  exportConfig: '导出配置',
  importPlugin: '上传数据源插件',
  more: '更多选项',
  message: {
    emptyName: '数据源名称不能为空',
    deleteSuccess: '删除数据源成功',
    deleteFailed: '删除数据源失败',
    addSuccess: '增加数据源成功',
    addFailed: '增加数据源失败',
    modifySuccess: '修改数据源成功',
    modifyFailed: '修改数据源失败',
    getDataError: '获取数据源信息失败',
    policyErr: '数据源名称格式不正确，不可包含特殊符号',
    emptyType: '数据源类型不能为空',
    emptyUrl: 'URL 不能为空',
    repeatName: '数据源名称重複',
    connectSuccess: '数据连接成功',
    connectFail: '数据连接失败',
    nameLengthLimit: '名称长度限制为 64 字元',
    importPluginSuccess: '导入插件成功',
    importPluginFailed: '导入插件失败',
    deletePluginSuccess: '删除插件成功',
    deletePluginFailed: '刪除插件失败',
    downloadPluginFailed: '下载插件失败',
    existedPlugin: '插件已存在',
    invalidPlugin: '插件无效',
    invalidZIPFile: '无效的ZIP文件',
    invalidPluginContent: '插件内容无效',
    PluginTooLarge: '插件文件太大',
    notEnableNodeRed: 'Data-Director 服务并未启动',
    importDataSourceSuccess: '导入数据源配置成功',
    importDataSourceFailed: '导入数据源配置失败',
    existedDataSourceName: '数据源名称重复，是否进行覆盖',
    emptyUser: '用户名不能为空',
    emptyPassword: '密码不能为空',
    emptyPort: '端口号不能为空',
    emptyDatabase: '数据库不能为空',
    emptySslMode: 'SSL Mode 不能为空',
    emptyIvsid: 'IVSID 不能为空',
    copySuccess: '拷贝成功'
  }
};

const user = {
  addUserInfo: '添加用户',
  alarm: '确认删除该用户？',
  remind: '提示',
  name: '用户名',
  type: '用户类型',
  search: '搜索用户',
  addUser: '+ 添加用户',
  limit: '0 个用户可添加',
  limitMessage: '标准版最多可以包含{num}个用户。要无限用户（以及更多），请升级到专业版。',
  manage: '管理',
  edit: '编辑',
  delete: '删除',
  save: '保存',
  cancel: '取消',
  email: '用户 ID ',
  select: '请选择',
  organization: '组织',
  addOrg: '+ 增加',
  selectOrg: '请选择组织',
  selectRole: '请选择角色',
  enterEmail: '请输入用户 ID ',
  enterPassword: '请输入密码',
  enterPasswordAgain: '请重新输入密码',
  enterUserName: '请输入用户名称',
  admin: '管理员',
  password: '密码',
  message: {
    repeatOrg: '组织选择重复，请重新选择',
    emptyOrg: '组织不能为空',
    emptyRole: '用户类型不能为空',
    emptyEmail: '用户 ID 不能为空',
    emptyPassword: '密码不能为空',
    inconsistentPassword: '两次输入密码不一致',
    deleteSuccess: '删除用户成功',
    deleteFailed: '删除用户失败',
    addFailedRepeatName: '添加用户失败，重复的用户 ID ',
    deleteFailedLastUser: '组织最少需要保留一位 Admin 用户',
    modifySuccess: '修改用户成功',
    modifyFailed: '修改用户失败',
    addSuccess: '增加用户成功',
    addFailed: '增加用户失败',
    duplicateKey: '增加用户失败，该用户已存在',
    unknownUser: '未能找到该用户，请先至主页用户管理新增该用户',
    getDataError: '获取用户信息失败',
    getUserOrgDataError: '获取用户绑定信息失败',
    deleteSelf: '您不能删除您自己',
    emptyUserNameEmail: '用户名称和用户 ID 不能为空',
    emailPolicyErr: '用户 ID 格式不正确',
    namePolicyErr: '用户名称格式不正确',
    nameLengthLimit: '名称长度限制为 64 字元'
  }
};

const sketchboard = {
  search: '搜索画图板',
  add: '+ 添加画图板',
  add3D: '+ 添加 3D画图板',
  spaceEditor: '空间编辑器',
  limit: '0 个{type}画图板可添加',
  limitMessage: '标准版最多可以包含{num}个{type}画图板。要无限{type}画图板（以及更多），请升级到专业版。',
  name: '画图板名称',
  displayType: '画图板类型',
  createdBy: '创建者',
  view: '查看',
  edit: '编辑',
  message: {
    getDataError: '获取画图板信息失败'
  }
};

const body = {
  home: '组织管理',
  organization: '组织',
  setting: '设定',
  orgList: '组织列表',
  userManagement: '用户管理',
  sketchboard: '画图板',
  dataSource: '数据源',
  user: '用户',
  systemSetting: '系统设定',
  userProfile: '用户偏好设定',
  version: '版本',
  menu: '选单'
};

const homePage = {
  title: 'Home/Organization chs'
};

const glb = {
  loading: '加载中',
  header: '顶栏',
  aside: '侧边栏',
  main: '主区域',
  date: {
    timeQuantum: '时间段',
    to: '至',
    startDate: '开始日期',
    endDate: '结束日期'
  },
  search: '搜索',
  placeholder: '请选择',
  apply: '应用',
  cancel: '取消'
};

const menu = {
  menuList: '选单列表',
  viewPage: '浏览',
  saveMenu: '存档',
  addNode: '添加节点',
  selectLangDetail: '设定项目语言显示名称及 sketchboard 连结',
  folder: '资料夹',
  file: '项目',
  menuName: '项目名称',
  sketchboardLink: 'Sketchboard 连结',
  defaultOpen: '预设开启',
  logo: 'Logo',
  logoImage: '图片',
  limitMessage: '对于客制化 logo，请升级到专业版。',
  logoSrc: '路径',
  logoDescript: '描述',
  menu: '选单',
  width: '宽度',
  modify: '修改',
  cancel: '取消',
  reset: '重设',
  openMenu: '预设开启',
  showIcon: '显示图示',
  openSetting: '开启配置',
  frameSetting: '框架设定',
  changeImage: '替换',
  clearImage: '清除',
  language: '语言',
  openLanguage: '开启语言切换',
  defaultLang: '预设语言',
  view: '预览',
  openLayerView: '叠加层预览',
  message: {
    addSuccess: '存档成功',
    addFailed: '存档失败',
    loadFailed: '獲取列表失败'
  }
}

const orgSetting = {
  bimEnable: '启用 BIM',
  viewLogin: '预览登入',
  outsideResource: '外部资源',
  saveMenu: '设定偏好',
  message: {
    addSuccess: '存档成功',
    addFailed: '存档失败',
    loadFailed: '獲取失败，使用预设'
  }
}

const en = {
  main,
  body,
  homePage,
  glb,
  orgList,
  dataSource,
  user,
  sketchboard,
  userProfile,
  systemSetting,
  versionHistory,
  menu,
  orgSetting
};

export default en



// WEBPACK FOOTER //
// ./src/js/lang/zh.js